const EXPLICIT_LOGOUT_FLOW_KEY = 'explicitLogoutInProgress';

const canUseSessionStorage = () => typeof window !== 'undefined' && !!window.sessionStorage;
const canUseLocalStorage = () => typeof window !== 'undefined' && !!window.localStorage;

export const beginExplicitLogoutFlow = () => {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(EXPLICIT_LOGOUT_FLOW_KEY, '1');
};

export const clearExplicitLogoutFlow = () => {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(EXPLICIT_LOGOUT_FLOW_KEY);
};

export const isExplicitLogoutFlowActive = () => {
  if (!canUseSessionStorage()) {
    return false;
  }

  return window.sessionStorage.getItem(EXPLICIT_LOGOUT_FLOW_KEY) === '1';
};

export const hasStoredAuthSession = () => {
  if (!canUseLocalStorage()) {
    return false;
  }

  return !!window.localStorage.getItem('token') && !!window.localStorage.getItem('currentUserRol');
};